import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, MaterialIcons } from '@iclinic/design-system';
import moment from 'moment';

import { getSchedulePaymentsList } from 'features/newFinance/state/selectors';
import { formatCurrency } from 'shared/utils/strings';
import { IPayment } from 'features/newFinance/types/types';
import { deletePaymentMethod } from 'features/newFinance/state/payment';
import {
  PaymentList as StyledPaymentList,
  PaymentItem as StyledPaymentItem,
  PaymentItemInfo,
} from './styles';
import { getIcon, getPaymentMethod } from './utils/utils';

const { Delete } = MaterialIcons;

type PaymentItemProps = {
  payment: IPayment;
};
const PaymentItem: React.FC<PaymentItemProps> = ({
  payment
}) => {
  const { paymentType, value, date } = payment;
  const dispatch = useDispatch();

  const handleDeletePayment = () => {
    dispatch(deletePaymentMethod(payment));
  };
  return (
    <StyledPaymentItem data-testid="payment_item">
      <PaymentItemInfo>
        {getIcon(paymentType)}
        <span className="payment-item-description">
          Pagamento em {getPaymentMethod(paymentType)}
        </span>
        <span className="payment-item-value">{formatCurrency(value)}</span>
        <IconButton size="sm" title="Deletar" onClick={handleDeletePayment}>
          <Delete />
        </IconButton>
      </PaymentItemInfo>
      <div>Recebido em {moment(date).format('DD/MM/YYYY')}</div>
    </StyledPaymentItem>
  );
};
const PaymentList = () => {
  const paymentList = useSelector(getSchedulePaymentsList);
  return (
    <StyledPaymentList>
      {paymentList.map(payment => (
        <PaymentItem key={payment.id} payment={payment}/>
      ))}
    </StyledPaymentList>
  );
};

export default PaymentList;
